module.exports = "/_next/static/images/bri-logo-272a7e63c45507dfd122d611f0ae2426.svg";